import React from 'react';
import { Endpoint } from '@hud/portal-dtos/webapp-endpoint.dto';
import { Popover } from '@hud/web-components/Popover/Popover';
import { APILabel, EndpointList, EndpointsLabel } from './MethodsPopover.styles';
import { getMethodsDisplay } from '../../utils';

interface MethodsPopoverProps {
  methods: Endpoint['methods'];
}

export function MethodsPopover({ methods }: MethodsPopoverProps) {
  if (methods.length === 0) {
    return;
  }

  //if methods have get or post, show that, otherwise show the first item
  const { methodsToPresent, methodOverflowString } = getMethodsDisplay(methods);

  return (
    <Popover
      body={
        <EndpointList>
          {methods.map((method) => (
            <div key={method}>{method.toLocaleUpperCase()}</div>
          ))}
        </EndpointList>
      }
    >
      {methods.length === 1 ? (
        <EndpointsLabel>
          <APILabel>{methodsToPresent}</APILabel>
        </EndpointsLabel>
      ) : (
        <EndpointsLabel>
          <APILabel>{methodsToPresent}</APILabel>
          {methodOverflowString}
        </EndpointsLabel>
      )}
    </Popover>
  );
}
